module.exports = __webpack_public_path__ + "static/media/Header.f3bd3ae6.png";